import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=427a220d"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports